import consumer from "./consumer"

$(document).ready(function () {
  consumer.subscriptions.create({
    channel: "SubscriptionChannel"
  }, {
    received(html) {
      $('#flash_messages').append(html.flash)
      flashMessages();
    }
  });
});
